var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('listagem',{attrs:{"search":_vm.search,"headers":_vm.headers,"data":_vm.data,"dataTotal":_vm.dataTotal,"pageSize":_vm.page_size},on:{"getItemsByPage":_vm.handleGetAgendamentos,"getItemsByItemsPerPage":_vm.handleGetAgendamentos,"cleanData":function($event){_vm.data = []},"deleteItem":_vm.deleteItem}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }